import React, { useEffect, useState } from 'react';
import { connect } from 'dva'
import PropTypes from 'prop-types'
import Chip from '../../Chip'
import KeyboardShortcutsContent2D from './KeyboardShortcutsContent2D';
import KeyboardShortcutsContent3D from './KeyboardShortcutsContent3D';
import KeyboardShortcutsIcon from '../../../assets/svg/KeyboardShortcutsIcon2';
import SidebarBody from '../SidebarBody'
import SidebarDetailHeader from '../SidebarDetailHeader';
import styles from './KeyboardShortcuts.module.scss'

function KeyboardShortcutsSidebar(props) {
  const tabs = [
    {
      title: '2D',
      component: <KeyboardShortcutsContent2D />,
    },
    {
      title: '3D',
      component: <KeyboardShortcutsContent3D />,
    },
  ]
  const tabIndex = tabs.findIndex(t => t.title === props.mapMode)
  const [activeTabIndex, setActiveTabIndex] = useState(tabIndex)

  const handleTabClick = (tabIndex) => {
		setActiveTabIndex(tabIndex)
	}

  useEffect(() => {
    const tabIndex = tabs.findIndex(t => t.title === props.mapMode)
    setActiveTabIndex(tabIndex)
  }, [props.mapMode])

  
  return (
    <>
      <SidebarDetailHeader
        title="Keyboard Shortcuts"
        titleIcon={<KeyboardShortcutsIcon />}
      />
      <>
					<div className={styles.container}>
						<div className={styles.iconTabs}>
							{tabs.map((t, i) => {
                const currentTheme = i === activeTabIndex ? Chip.THEME.white : Chip.THEME.outlinePrimary
								return (
									<Chip key={i} size={Chip.SIZE.small} theme={currentTheme} onClick={() => handleTabClick(i)} >
										{t.title}
									</Chip>
								)
							})}
						</div>
					</div>
					<SidebarBody>{tabs[activeTabIndex].component}</SidebarBody>
				</>
    </>
  );
}

KeyboardShortcutsSidebar.propTypes = {
  mapMode: PropTypes.string
}

export default connect((model) => {
  const { mapMode } = model.map
  return {
    mapMode
  }

})(KeyboardShortcutsSidebar)